import gql from "graphql-tag";
import fetch from "node-fetch";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

const QUERY_getdetailhome = gql`
  query getdetailhome(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getdetailhome(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      homeid
      address
      lat
      lang
      bedCount
      bathCount
      price
      squareFeet
      homemimages
      ListingKeyNumeric
      BedroomsTotal
      BathroomsTotalInteger
      BathroomsFull
      BathroomsHalf
      City
      Country
      CountyOrParish
      Latitude
      Longitude
      ListAgentFullName
      ListAgentStateLicense
      ListAgentMLS
      ListPrice
      LivingArea
      ListOfficeName
      LotSizeArea
      LotSizeUnits
      ListingId
      MlsStatus
      ModificationTimestamp
      PostalCode
      PropertyType
      PropertySubType
      PostalCity
      PublicRemarks
      StandardStatus
      StateOrProvince
      SourceId
      ThumbnailUrl
      UnparsedAddress
      YearBuilt
      ClosePrice
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Get list by own query
async function getdetailhomelist(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getdetailhome,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export { getdetailhomelist };
